<script setup lang="ts">
import UiModal from '@boats/ui/components/UiModal.vue'

const modals = useModalsStore()
</script>

<template>
  <UiModal
    v-model="modals.isForgotPasswordModalOpen"
    mobile-full-screen
    class="app-modal-forgot-password"
    @close="modals.closeForgotPasswordModal"
  >
    <h2 class="h1 mb-2">{{ $t('modal.forgot-password.title') }}</h2>

    <p class="mb-5 md:mb-8">
      {{ $t('modal.forgot-password.description') }}
    </p>

    <AppFormForgotPassword class="mb-5 md:mb-8" />

    <p class="mb-5 md:mb-8">
      {{ $t('modal.forgot-password.login.text') }}
      <a
        role="button"
        @click="
          () => {
            modals.openLoginModal()
            modals.closeForgotPasswordModal()
          }
        "
      >
        {{ $t('string.Login') }}
      </a>
    </p>
  </UiModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-forgot-password {
  .ui-modal__content {
    text-align: center;

    @include media-breakpoint-up(md) {
      h2 {
        font-size: 2.625rem;
        font-weight: 400;
        line-height: 1;
      }
    }
  }
}
</style>
